module.exports = __webpack_public_path__ + "img/splash.150522eb.png";